import {useContext, useState,useEffect, FC} from 'react'
import {Droppable, Draggable} from 'react-beautiful-dnd'
import {useAccordionButton} from 'react-bootstrap/AccordionButton'
import {Card, Accordion, Badge} from 'react-bootstrap'
import {title} from 'process'
import Collapsible from 'react-collapsible'
import {KTIcon} from '../../../../../../../_metronic/helpers'
import {PartnerContext} from '../../../PartnerContexts'
import {DraggableFieldList} from './DraggableFieldList'
import { Seccion } from '../../../../../documentacion/MiFicha/FIchaInterface'
import { Section } from '../../../../fichas/Sheet'

const grid = 4

const getItemStyle = (isDragging: boolean, draggableStyle: any) => ({
  // Some basic styles to make the items look a bit nicer
  userSelect: 'none',
  padding: grid * 2,
  margin: `0 0 ${grid}px 0`,

  // Change background color if dragging
  background: isDragging ? '#18c073' : 'white',
  borderRadius: 10,
  // Styles we need to apply on draggables
  ...draggableStyle,
})

interface MyComponentProps {
  item: Section;
  ind:number;
  index:number;
  onUpdate: (updatedData: any) => void;
}

const CollapsibleSectionItem : FC<MyComponentProps> = (props) => {
  let {item,ind,index,onUpdate} = props
  const [formDataSeccion, setFormDataSeccion] = useState<Section>(item);

  useEffect(() => {
    setFormDataSeccion(item)
  }, [formDataSeccion])

  const handleUpdateSeccion = (updatedData:Section) => {
    onUpdate(updatedData)
  };

  return (
    <>
      {
    
        <Draggable draggableId={`Sec`+formDataSeccion.id} index={index}>
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              {...provided.draggableProps}
              
              style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}
            >
              <div style={{position: 'relative'}}>
                <div {...provided.dragHandleProps} style={{position: 'absolute', top: '0', left: '0'}}>
                  <Badge
                    bg='success-active'
                    className='me-2'

                    style={{transform: 'translateY(-2px)', color: 'white'}}
                  >
                    {index + 1}
                  </Badge>
                </div>
                
                <Collapsible transitionTime={200} open={true} easing='ease' trigger={formDataSeccion.name} triggerStyle={{marginLeft: 30, fontWeight:'bolder'}}>
                  <div className='mt-3 mx-10'>
                    <DraggableFieldList 
                      key={`FiL`+formDataSeccion.id} 
                      indProcesoFicha={ind} 
                      sectionItem={formDataSeccion}                 
                      onUpdate={(updatedData) => handleUpdateSeccion(updatedData)} 

                    />
                  </div>
                </Collapsible>


                {/* <div style={{position: 'absolute', top: '0', right: '0'}}>
                  <Badge
                    bg='primary-active'
                    className='me-2'
                    style={{transform: 'translateY(-8px)', color: 'white'}}
                  >
                    {item.campos.fields?.length || 0}
                  </Badge>
                </div> */}
              </div>
            </div>
          )}
        </Draggable>

      }
    </>
    
    
  )
}

export {CollapsibleSectionItem}
